interface OrderItem {
  id: string;
  orderId: string;
  courseId: string;
  courseName: string;
  courseLogo?: string;
  title: string;
  amount: number;
  date: string;
  createdAt?: string;
  payTime?: string;
  payType?: number;
  status: 'paid' | 'pending' | 'closed';
}

const STATUS_TEXT = {
  paid: '支付成功',
  pending: '待支付',
  closed: '已关闭'
};

const PAY_TYPE_TEXT: Record<number, string> = {
  31: '空中雲匯',
  100: '餘額'
};

const OrderHistory = ({
  orders,
  onContinuePay
}: {
  orders: OrderItem[];
  onContinuePay: (id: string) => void;
}) => {
  return (
    <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
      {orders.length === 0 ? (
        <div className="py-16 text-center text-slate-400 text-sm">暫無課程訂單</div>
      ) : (
        <div className="divide-y divide-slate-50">
          {orders.map((order) => (
            <div key={order.id} className="px-6 py-4 flex items-center justify-between gap-4">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-14 h-14 rounded-xl overflow-hidden bg-slate-100 flex items-center justify-center flex-shrink-0">
                  {order.courseLogo ? (
                    <img src={order.courseLogo} alt={order.courseName} className="w-full h-full object-cover" />
                  ) : (
                    <i className="ri-book-open-line text-slate-400 text-lg" />
                  )}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-[#0A1628] truncate">{order.courseName || order.title}</p>
                  <p className="text-[11px] text-slate-400 mt-1 font-mono truncate">訂單號：{order.orderId}</p>
                  <p className="text-[11px] text-slate-400 mt-1 truncate">課程 ID：{order.courseId || '--'}</p>
                </div>
              </div>
              <div className="flex items-center gap-5">
                <div className="text-right">
                  <p className="text-sm font-bold text-[#0A1628]">${order.amount}</p>
                  <p className="text-[11px] text-slate-400 mt-1">建立：{order.createdAt || '--'}</p>
                  <p className="text-[11px] text-slate-400 mt-1">支付：{order.payTime || '--'}</p>
                  <p className="text-[11px] text-slate-400 mt-1">方式：{PAY_TYPE_TEXT[Number(order.payType || 0)] || '--'}</p>
                  <p className="text-[11px] text-violet-600 mt-1">{STATUS_TEXT[order.status]}</p>
                </div>
                {order.status === 'pending' ? (
                  <button
                    onClick={() => onContinuePay(order.id)}
                    className="rounded-xl bg-emerald-600 px-4 py-2 text-xs font-bold text-white transition-colors hover:bg-emerald-700"
                  >
                    繼續付款
                  </button>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrderHistory;
